import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({
  isAuthenticated,
  requireAdmin = false,
  requireSuperAdmin = false,
  userIsAdmin = false,
  userIsSuperAdmin = false,
  children,
}) {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireSuperAdmin && !userIsSuperAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireAdmin && !userIsAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default ProtectedRoute;
